import React from 'react';
import { Button } from '@material-ui/core';
import { isFreqOrder } from '@mummssoftware/utils/orders/orders-utils';
import { CreateOrderButtonsDiv } from './layout/WrapperDiv';
import en from '../translationDefaults/en';
export const VerifyOrderButtons = ({
  onCancelClick,
  onOrderVerified,
  onModifyClick,
  orderVerified,
  orderType
}) => /*#__PURE__*/React.createElement(CreateOrderButtonsDiv, null, /*#__PURE__*/React.createElement(Button, {
  title: "OK",
  size: "small",
  variant: "contained",
  color: "primary",
  disabled: !orderVerified,
  onClick: onOrderVerified
}, en.orderVerifiedCheck), /*#__PURE__*/React.createElement(Button, {
  title: "Cancel",
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onCancelClick
}, en.cancel), isFreqOrder(orderType) && /*#__PURE__*/React.createElement(Button, {
  title: "Cancel",
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onModifyClick
}, en.modifyDetails) || null);
export default VerifyOrderButtons;